<app-nav-menu></app-nav-menu>
<div class="Main_page">

  <div class="row m-0 p-0">
    <ng-template #sweet let-modal>

      <div class="p-3">
        <div class="card-title">
          <p>Trip Details!</p>
        </div>
        <div class="row m-0">
          <div class="col-md-4 p-0 ">
            <ng-select class="country-issuance-Class   countryOfIssueclass " [items]="airportGetList"
                       bindLabel="city" bindValue="iataCode" id="clasairrborderfrom"
                       [searchable]="true"
                       placeholder="Select" name="fromAirport" [(ngModel)]="tripdetailobj.fromAirport">
              <ng-template ng-option-tmp let-item="item">
                <div class="line" style="font-size:11px">{{item.city}}-{{item.iataCode}}</div>

              </ng-template>
            </ng-select>
            <label class="input_lab_first" id="labelairfrom">From Airport</label>
            <span class="first-required" id="frommessageair">ddddd</span>
          </div>
          <div class="col-md-4 p-0 pl-1">
            <ng-select class="country-issuance-Class   countryOfIssueclass" [items]="airportGetList"
                       bindLabel="city" bindValue="iataCode" id="clasairrborderto"
                       [searchable]="true"
                       placeholder="Select" name="toAirport" [(ngModel)]="tripdetailobj.toAirport">
              <ng-template ng-option-tmp let-item="item">
                <div class="line" style="font-size:11px">{{item.city}}-{{item.iataCode}}</div>

              </ng-template>
            </ng-select>
            <label class="input_lab_first" id="labelairto">To Airport</label>
            <span class="first-required" id="tomessageair">ddd</span>
          </div>
          <div class="col-md-4 p-0 pl-1">
            <select class="new_input_popupfields" name="journeyType" id="clasJourneyborderto" [(ngModel)]="tripdetailobj.journeyType">
              <option>
                OW
              </option>
              <option>
                RT
              </option>
              <option>
                MC
              </option>

            </select>

            <label class="input_lab_first" id="labelJourney">Journey Type</label>
            <span class="first-required" id="messageJourney">ddd</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-9">

        </div>
        <div class="col-md-3 p-0">
          <button class="Buttonok" (click)="clickTripDetailsBtn()">OK</button>
        </div>
      </div>




      <!--<div class="card-text">
        <p>Yay! It's a nice order! <br>It will arrive soon.</p>
      </div>--->


    </ng-template>

    <div class="col-md-12 p-0">
      <div class="SearchPannel ">
        <div class="row m-0">

          <div class="heading_page">
            <span>Booking Search</span>
          </div>
        </div>
        <div class="row m-0 mt-3">
          <div class="col-md-11 p-0">
            <div class="row m-0 mt-1">

              <div class="col-md-2 p-0">
                <input type="date" class="new_input_fields" name="fromBookingDate" [(ngModel)]="bookingsearchobj.fromBookingDate">
                <label class="input_lab_first">Booking From</label>
              </div>
              <div class="col-md-2 p-0 pl-1">

                <input type="date" class="new_input_fields" name="toBookingDate" [(ngModel)]="bookingsearchobj.toBookingDate">
                <label class="input_lab_first">Booking To</label>
              </div>
              <div class="col-md-2 p-0 pl-1">

                <input type="number" class="new_input_fields" name="bookingID" [(ngModel)]="bookingsearchobj.bookingID">
                <label class="input_lab_first">Booking ID</label>
              </div>
              <div class="col-md-2 p-0  pl-1">

                <ng-select [items]="spdata" bindLabel="supplierName" bindValue="supplierId" [searchable]="true"
                           class="statusselect" name="supplier" [(ngModel)]="bookingsearchobj.supplier">
                </ng-select>
                <label class="input_lab_first">Supplier</label>
              </div>
              <div class="col-md-2 p-0 pl-1 ">

                <input type="text" class="new_input_fields" name="pnr" [(ngModel)]="bookingsearchobj.pnr">
                <label class="input_lab_first">PNR</label>
              </div>
              <div class="col-md-2 p-0 pl-1">
                <input type="date" class="new_input_fields" name="travelDate" [(ngModel)]="bookingsearchobj.travelDate">
                <label class="input_lab_first">Traveling Date</label>
              </div>
            </div>
            <div class="row m-0 mt-3">


              <div class="col-md-2 p-0 ">

                <input type="text" class="new_input_fields" name="tkt" [(ngModel)]="bookingsearchobj.tkt">
                <label class="input_lab_first">Ticket No</label>
              </div>
              <div class="col-md-2 p-0 pl-1">


                <input type="text" class="new_input_fields" name="trip" [(ngModel)]="bookingsearchobj.trip" (click)="trippopup(sweet)" readonly>
                <label class="input_lab_first">Trip</label>
              </div>
              <div class="col-md-3 p-0 pl-1">


                <input type="text" class="new_input_fields" name="name" [(ngModel)]="bookingsearchobj.name">
                <label class="input_lab_first">Name</label>
              </div>
              <div class="col-md-3 p-0 pl-1 ">

                <ng-select [items]="agencyCodefinalList$ | async" bindLabel="labelName" bindValue="code" [searchable]="true"
                           class="statusselect" name="byAgency" [(ngModel)]="bookingsearchobj.byAgency">
                </ng-select>
                <label class="input_lab_first">By Agency</label>
              </div>
              <div class="col-md-2 p-0  pl-1">

                <ng-select [items]="bookingstatusList$ | async" bindLabel="bookingStatus" bindValue="id" [searchable]="true"
                           class="statusselect" name="bookingStatus" [(ngModel)]="bookingsearchobj.bookingStatus">
                </ng-select>
                <label class="input_lab_first">Status</label>
              </div>



            </div>
          </div>
          <div class="col-md-1">

            <button (click)="LoadButtonClick()" class="LoadButton">
              Load
              <span class="load loading">
              </span>
            </button>

          </div>
        </div>


      </div>
    </div>


  </div>
  <br />
  <dx-data-grid #listGrid
                [dataSource]="bookingList"
                [showBorders]="true"
                [showRowLines]="true"
                [columnAutoWidth]="true"
                (onContentReady)="contentReady($event)"
                (onExporting)="onExporting($event)">
    <dxo-grouping [autoExpandAll]="true"></dxo-grouping>
    <dxo-selection mode="multiple"></dxo-selection>
    <dxo-scrolling mode="standard"></dxo-scrolling>
    <dxo-paging [pageSize]="100"></dxo-paging>
    <dxo-pager [visible]="true"
               [showInfo]="infoText" [infoText]="infoText"
               [showNavigationButtons]="true"></dxo-pager>
    <dxi-button name="save"
                cssClass="my-class">
    </dxi-button>
    <dxi-column dataField="title" alignment="center" caption="Title"></dxi-column>
    <dxi-column dataField="bookingDate" alignment="center" caption="Booking Date"></dxi-column>
    <dxi-column [visible]="false" dataField="bookingID" alignment="center" caption="Booking ID"></dxi-column>
    <dxi-column dataField="agencyId" alignment="center" caption="Booking ID"></dxi-column>
    <dxi-column dataField="supplier" alignment="center" caption="Supplier"></dxi-column>
    <dxi-column dataField="pnr" alignment="center" caption="PNR"></dxi-column>
    <dxi-column dataField="tkt" alignment="center" caption="TKT"></dxi-column>
    <dxi-column dataField="trip" alignment="center" caption="Trip"></dxi-column>
    <dxi-column dataField="name" alignment="center" caption="Name"></dxi-column>
    <dxi-column dataField="travelDate" alignment="center" caption="Travel Date"></dxi-column>
    <dxi-column dataField="bookingStatus" alignment="center" caption="Status"></dxi-column>
    <dxi-column caption="Action" [allowSorting]="false" alignment="center" cellTemplate="actionCellTemplate"></dxi-column>
    <!--<dxo-search-panel [visible]="true"></dxo-search-panel>-->
    <div *dxTemplate="let data of 'actionCellTemplate'">
      <a (click)="Edit_Click(data.data)"><i class="uil uil-edit action-class">Manage</i></a>
    </div>
    <!--<div *dxTemplate="let data of 'cellTemplate'">
    <div class="custom_margin disabled-btn" id="disabled-btn">
      <label class="switch">
        <input type="checkbox" name="isActive" [(ngModel)]="data.data.isActive">
        <span></span>
      </label>
    </div>
  </div>-->
    <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
  </dx-data-grid>
  <div class="buttonNextdiv ">

    <button (click)="NextButtonClick()" class="NextButton hiddenclass" id="buttonnext">
      Next
      <span class="next loadings">

      </span>
    </button>

  </div>
  <div id="errortext" class="hidemarginss">


    <span class="alert alert-danger" style=" position: relative; bottom: 40px;" id="Message_next"></span>
  </div>
</div>


